module.exports = __webpack_public_path__ + "static/media/icon-lp-schedule.472e4406.svg";